import React from 'react';

const WebCustomizationContext = React.createContext({
  webCustomizationDoc: null,
});

export default WebCustomizationContext;
